import { z } from 'zod';
/**
 * Social contract for followers/following sync and cookie management
 * Requires authentication
 */

// Constants
export const SOCIAL_SYNC_MAX_LIMIT = 50_000;

// Social sync request/response schemas
export const SocialSyncRequestSchema = z.object({
  syncType: z.enum(['followers', 'following', 'both']).default('both'),
  limit: z.number().int().min(1).max(SOCIAL_SYNC_MAX_LIMIT).default(1000),
});

export type SocialSyncRequest = z.infer<typeof SocialSyncRequestSchema>;

export const SocialSyncResponseSchema = z.object({
  success: z.boolean(),
  syncJobId: z.string(),
  message: z.string(),
});

export type SocialSyncResponse = z.infer<typeof SocialSyncResponseSchema>;

// Social sync status response
export const SocialSyncStatusResponseSchema = z.object({
  id: z.string().optional(),
  status: z.string(),
  progress: z.number().optional(),
  metadata: z.unknown().optional(),
  error: z.string().nullable().optional(),
  startedAt: z.date().nullable().optional(),
  completedAt: z.date().nullable().optional(),
  processedItems: z.number().optional(),
  totalItems: z.number().optional().nullable(),
  newItems: z.number().nullable().optional(),
  updatedItems: z.number().nullable().optional(),
  message: z.string().optional(),
});

export type SocialSyncStatusResponse = z.infer<typeof SocialSyncStatusResponseSchema>;

// Social sync cancel response
export const SocialSyncCancelResponseSchema = z.object({
  success: z.boolean(),
  status: z.string(),
  id: z.string().optional(),
});

export type SocialSyncCancelResponse = z.infer<typeof SocialSyncCancelResponseSchema>;

// Cookie management schemas
export const SocialCookiesStatusResponseSchema = z.object({
  hasCookies: z.boolean(),
  lastUpdated: z.date().nullable(),
});

export type SocialCookiesStatusResponse = z.infer<typeof SocialCookiesStatusResponseSchema>;

export const SocialCookiesUpdateRequestSchema = z.object({
  cookies: z.string().min(1),
});

export type SocialCookiesUpdateRequest = z.infer<typeof SocialCookiesUpdateRequestSchema>;

export const SocialCookiesUpdateResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
});

export type SocialCookiesUpdateResponse = z.infer<typeof SocialCookiesUpdateResponseSchema>;

export const SocialCookiesDeleteResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
});

export type SocialCookiesDeleteResponse = z.infer<typeof SocialCookiesDeleteResponseSchema>;

// Social stats (placeholder)
